import type {
  ChannelKind,
  EmployeeStatus,
  IncidentStatus,
  InviteStatus,
  LinkStatus,
  OutboxStatus,
  PersonStatus,
  ProjectStatus,
  RequestStatus,
  RequestType,
  Role,
  RunStatus,
  ScheduleStatus,
  TemplateStatus,
} from './enums';
import type { ProjectionKind } from './integration';

/**
 * §19 ТЗ: интерфейс русский. Единый словарь подписей для значений enum'ов.
 *
 * Словарь общий для админки и сервера: выгрузка CSV (§14, E9) обязана
 * называть статус ровно так же, как таблица на экране, а два отдельных
 * перевода одного enum'а расходятся на первой же правке.
 */

export const ROLE_LABEL: Record<Role, string> = {
  SYS_ADMIN: 'Системный администратор',
  MANAGER_HEAD: 'Руководитель менеджеров',
  PROJECT_MANAGER: 'Менеджер объекта',
  ANALYST: 'Аналитик',
};

export const PROJECT_STATUS_LABEL: Record<ProjectStatus, string> = {
  ACTIVE: 'Действует',
  INACTIVE: 'Приостановлен',
  ARCHIVED: 'В архиве',
};

export const EMPLOYEE_STATUS_LABEL: Record<EmployeeStatus, string> = {
  ACTIVE: 'Действует',
  BLOCKED: 'Заблокирован',
  ARCHIVED: 'В архиве',
};

export const PERSON_STATUS_LABEL: Record<PersonStatus, string> = {
  ACTIVE: 'Действует',
  BLOCKED: 'Заблокирован',
};

export const LINK_STATUS_LABEL: Record<LinkStatus, string> = {
  INVITED: 'Приглашён',
  ACTIVE: 'Действует',
  REVOKED: 'Отозвана',
};

export const INVITE_STATUS_LABEL: Record<InviteStatus, string> = {
  ACTIVE: 'Действует',
  USED: 'Использовано',
  EXPIRED: 'Истекло',
  REVOKED: 'Отозвано',
};

export const CHANNEL_LABEL: Record<ChannelKind, string> = {
  TELEGRAM: 'Telegram',
  MAX: 'MAX',
};

export const TEMPLATE_STATUS_LABEL: Record<TemplateStatus, string> = {
  DRAFT: 'Черновик',
  PUBLISHED: 'Опубликована',
  ARCHIVED: 'В архиве',
};

export const SCHEDULE_STATUS_LABEL: Record<ScheduleStatus, string> = {
  ACTIVE: 'Включено',
  PAUSED: 'Приостановлено',
  DISABLED: 'Отключено',
};

export const RUN_STATUS_LABEL: Record<RunStatus, string> = {
  SCHEDULED: 'Запланирован',
  SENT: 'Отправлен',
  IN_PROGRESS: 'Заполняется',
  COMPLETED: 'Завершён',
  EXPIRED: 'Просрочен',
  CANCELLED: 'Отменён',
};

export const INCIDENT_STATUS_LABEL: Record<IncidentStatus, string> = {
  NEW: 'Новый',
  IN_PROGRESS: 'В работе',
  CLOSED: 'Закрыт',
  REJECTED: 'Отклонён',
};

export const REQUEST_STATUS_LABEL: Record<RequestStatus, string> = {
  NEW: 'Новое',
  ACCEPTED: 'Принято',
  IN_PROGRESS: 'В работе',
  CLOSED: 'Закрыто',
  REJECTED: 'Отклонено',
};

export const REQUEST_TYPE_LABEL: Record<RequestType, string> = {
  COMPLAINT: 'Жалоба',
  EXTRA_SERVICE: 'Доп. услуга',
  CHANGE_SERVICE: 'Изменение услуги',
};

export const OUTBOX_STATUS_LABEL: Record<OutboxStatus, string> = {
  PENDING: 'В очереди',
  IN_PROGRESS: 'Выполняется',
  DONE: 'Выполнена',
  FAILED: 'Ошибка',
  NEEDS_ATTENTION: 'Требует внимания',
  NEEDS_RECONCILIATION: 'Требует сверки',
};

/** «Да»/«» вместо true/false: пустая ячейка в таблице читается быстрее слова «нет». */
export const YES_LABEL = 'Да';

/** §17.3. Что именно должно было спроецироваться в Bitrix24. */
export const PROJECTION_KIND_LABEL: Record<ProjectionKind, string> = {
  CRM_CONTACT: 'Контакт в CRM',
  LIST_ROW: 'Строка списка администраторов',
  TASK: 'Задача',
};
